var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,staticStyle:{"cursor":"pointer"},attrs:{"data-href":_vm.link},on:{"click":_vm.clickHandler}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }